// @ts-strict-ignore
import { createSelector } from 'reselect';
import type { State } from '~/store';
import { selectNodeLineageForAnchorNode } from './graph';
import {
  computeEdgeState,
} from 'flow/service/graph';

export const selectEdgeState = createSelector(
  [
    (state: State) => state.workflowEditor.ui.activeNodeEditorTab,
    (state: State) => state.workflowEditor.ui.canvasProperties.isMoving,
    (state: State) => state.workflowEditor.ui.focusedNodeId,
    (state: State) => state.workflowEditor.ui.hoveredNodeId,
    selectNodeLineageForAnchorNode,
    (state: State, sourceAndTargetId: [string, string]) => sourceAndTargetId,
  ],
  (
    activeNodeEditorTab,
    isMoving,
    focusedNodeId,
    hoveredNodeId,
    nodeLineage,
    [sourceId, targetId],
  ) => computeEdgeState({
    nodeLineage,
    sourceId,
    targetId,
    uiStatePartial: {
      activeNodeEditorTab,
      focusedNodeId,
      hoveredNodeId,
      isMoving,
    },
  }),
);

